import React from "react"
import NavbarLogo from "./images/reactIcon.png"

export default function Navbar(){
    return (
        <nav>
            <a href="https://react.dev/" target="_blank"><img className="navbar-logo" src={NavbarLogo}/>
            </a>
            <h3 className="navbar-logo-text">ReactFacts</h3>
            <h4 className="navbar-title">React1</h4>
        </nav>
    )
}